import BaseModel from './BaseModel'
import { ChannelFacility } from './ChannelFacility'
import { DefaultRate } from './DefaultRate'

export default class ChannelDefaultRate extends BaseModel {

  static entity = 'channel_default_rates'
  static primaryKey = 'ID'

  declare ID: number
  declare defaultRateID: number
  declare channelCost: number
  declare channel: string
  declare channelFacilitiesID: number
  declare channelRateData: object | null
  declare channelFacility: ChannelFacility
  declare defaultRate: DefaultRate
  declare status: string

  static fields() {

    return {

      // fields
      ID: this.number(null),
      defaultRateID: this.number(null),
      channelCost: this.number(null),
      channel: this.string(null),
      channelFacilitiesID: this.number(null),
      channelRateData: this.attr(null).nullable(),
      status: this.string(null).nullable(),

      // relationships
      channelFacility: this.belongsTo(ChannelFacility, 'channelFacilitiesID'),
      defaultRate: this.belongsTo(DefaultRate, 'defaultRateID'),

    }

  }

}
